import React, {useMemo} from "react";
import {FormattedMessage} from "react-intl";
import {Badge} from "peggirkit";
import {EmployeeTimeEntry} from "@/data/entities/employee";
import {HhMm, minutesToHhMm} from "@/utils/DateUtils";


export type TimeDiff = {
    timeEntry: EmployeeTimeEntry,
    clockedMinutes: number,
    workedMinutes: number,
};

export function getTimeDifference(timeEntry: EmployeeTimeEntry): TimeDiff | null {
    const {clockIn, clockOut, breakMinutes} = timeEntry
    if (clockOut === null)
        return null

    const start = new Date(clockIn);
    const end = new Date(clockOut);
    const diffMs: number = end.getTime() - start.getTime();
    const clockedMinutes: number = Math.floor(diffMs / (1000 * 60));
    return {
        timeEntry,
        clockedMinutes,
        workedMinutes: clockedMinutes - breakMinutes,
    };
}

type Props = {
    timeEntry: EmployeeTimeEntry,
};

const WorkedHoursSummaryFormatter = ({timeEntry}: Props) => {
    const diff: TimeDiff | null = useMemo(() => getTimeDifference(timeEntry), [timeEntry]);

    if (diff === null) {
        return (
            <Badge color={"primary"}>
                <FormattedMessage id={"notYetClockedOut"}/>
            </Badge>
        );
    }

    const {hours, minutes}: HhMm = minutesToHhMm(diff.workedMinutes);
    return (
        <Badge color={"success"}>
            <FormattedMessage
                id={"formattedHoursMinutes"}
                values={{hours, minutes}}
            />
        </Badge>
    );
};

export default WorkedHoursSummaryFormatter;